import styled from "styled-components";
export const StyledDivider = styled.hr `
  box-sizing: border-box;
  border: none;
  margin-block-start: 0;
  margin-block-end: 0;

  ${({ alignment }) => alignment === "vertical"
    ? `
        height: 100%;
        width: 1px;
        border-left: 1px solid;`
    : `
        width: 100%;
        height: 1px;
        border-top: 1px solid;`}

  ${({ inverted, theme }) => inverted
    ? `border-color: rgba(${theme.colors.transparentWhite},0.36);`
    : `border-color: rgba(${theme.colors.transparentBlack},0.16);`}
`;
